import apiClient from './axios';

// Публічний API для неавторизованих користувачів
export const publicApi = {
  // Отримати дані для головної сторінки
  getHomePageData: () => {
    return apiClient.get('/public/home');
  },
  
  // Отримати всі активні категорії
  getCategories: () => {
    return apiClient.get('/public/categories');
  },
  
  // Отримати всі активні знижки
  getDiscounts: () => {
    return apiClient.get('/discounts');
  },
  
  // Отримати знижки за категорією
  getDiscountsByCategory: (categoryId) => {
    return apiClient.get(`/discounts/category/${categoryId}`);
  },
  
  // Отримати знижки за партнером
  getDiscountsByPartner: (partnerId) => {
    return apiClient.get(`/discounts/partner/${partnerId}`);
  },
  
  // Отримати знижки за типом
  getDiscountsByType: (type) => {
    return apiClient.get(`/discounts/type/${type}`);
  },
  
  // Пошук знижок
  searchDiscounts: (query) => {
    return apiClient.get(`/public/discounts/search?query=${encodeURIComponent(query)}`);
  },
  
  // Отримати деталі знижки
  getDiscountDetails: (id) => {
    return apiClient.get(`/public/discounts/${id}`);
  },
  
  // Отримати нещодавні знижки
  getRecentDiscounts: (limit = 5) => {
    return apiClient.get(`/discounts/recent?limit=${limit}`);
  },
  
  // Отримати знижки, що закінчуються
  getExpiringDiscounts: () => {
    return apiClient.get('/discounts/expiring');
  },
  
  // Отримати всіх партнерів
  getPartners: () => {
    return apiClient.get('/partners');
  },
  
  // Отримати деталі партнера
  getPartnerDetails: (id) => {
    return apiClient.get(`/partners/${id}`);
  },
  
  // Отримати знижки партнера
  getPartnerDiscounts: (partnerId) => {
    return apiClient.get(`/discounts/partner/${partnerId}`);
  },
  
  // Отримати публічні департаменти для реєстрації
  getDepartments: () => {
    return apiClient.get('/public/departments');
  },
  
  // Отримати контактну інформацію
  getContactInfo: () => {
    return apiClient.get('/public/contact');
  }
};

export default publicApi;